import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Cursor from "@/components/site/Cursor";
import { EnquiryProvider } from "@/components/site/EnquiryProvider";
import { PaymentProvider } from "@/components/site/PaymentProvider";
import useLenis from "@/hooks/useLenis";

function App() {
  useLenis();

  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <Cursor />
      <EnquiryProvider>
        <PaymentProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
            </Routes>
          </BrowserRouter>
        </PaymentProvider>
      </EnquiryProvider>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#2C241E",
              color: "#F4F0EA",
              border: "1px solid rgba(244,240,234,0.15)",
              borderRadius: 0,
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
    </div>
  );
}

export default App;
